import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#check)",
		children: /* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2,
			d: "m13.5 4.5-7 7L3 8"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "check",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgCheck;
